import React from "react"
import styles from "./Gallery.module.css"
import FadeInSection from "../FadeInSection/FadeInSection"
import { SRLWrapper } from "simple-react-lightbox"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import "../../layout.css"

const useGallery = () => {
  const data = useStaticQuery(graphql`
    query gallery {
      allFile(
        filter: { sourceInstanceName: { eq: "gallery" } }
        sort: { fields: name }
      ) {
        nodes {
          id
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  return data.allFile.nodes.map(node => ({
    ...node.childImageSharp,
    id: node.id,
  }))
}

const Gallery = () => {
  const images = useGallery()

  return (
    <div className={styles.container} id="gallery-page">
      <div className={styles.content}>
        <FadeInSection>
          <div className={styles.description}>
            <h1 className="bigTitleLight">Our Work</h1>
            <h2 className="smallTitleLight">
              Check out some of the work we've done in the past
            </h2>
            <div className="line"></div>
          </div>
          <SRLWrapper>
            <div className={styles.gallery}>
              {images.map(({ id, fluid }) => (
                <Img key={id} fluid={fluid} />
              ))}
            </div>
          </SRLWrapper>
          <Link
            to="/AllGallery/"
            state={{
              modal: true,
            }}
          >
            <button className={styles.viewAllBtn}>View All</button>
          </Link>
        </FadeInSection>
      </div>
    </div>
  )
}

export default Gallery
